import type { GeoPoint } from "@repo/design-system/types/geo";

// From: https://stackoverflow.com/a/65799152/5587737
export function getDistanceBetweenTwoPoints(
  cord1: GeoPoint,
  cord2: GeoPoint
): number {
  if (cord1[0] === cord2[0] && cord1[0] === cord2[0]) {
    return 0;
  }

  const radlat1 = (Math.PI * cord1[0]) / 180;
  const radlat2 = (Math.PI * cord2[0]) / 180;

  const theta = cord1[0] - cord2[0];
  const radtheta = (Math.PI * theta) / 180;

  let dist =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);

  if (dist > 1) {
    dist = 1;
  }

  dist = Math.acos(dist);
  dist = (dist * 180) / Math.PI;
  dist = dist * 60 * 1.1515;
  dist *= 1.609_344; //convert miles to km

  return dist;
}
